import { MESApiService, spParameter } from "@dexteel/mesf-core";
import { get } from "lodash-es";
import { BreakLine, BreakRule, BreakRuleImpact } from "../models/BreakRule";

export const getBreakRules = async (
	assetId: number | null = null,
): Promise<{ rules: BreakRule[]; lines: BreakLine[] }> => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [{ name: "AssetId", value: assetId }];
	const resp = await apiService.callV2("[FAB].[GetBreakRules]", parameters);

	if (resp.ok) {
		return {
			rules: get(resp, "data.tables[0].rows", []) as BreakRule[],
			lines: get(resp, "data.tables[1].rows", []) as BreakLine[],
		};
	}
	throw new Error(resp.message || "Error fetching break rules");
};

export const getBreakRuleImpact = async (
	breakRuleId: number,
): Promise<BreakRuleImpact> => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [
		{ name: "BreakRuleId", value: breakRuleId },
	];
	const resp = await apiService.callV2(
		"[FAB].[GetBreakRuleImpact]",
		parameters,
	);

	if (resp.ok) {
		return get(resp, "data.tables[0].rows[0]", {
			Untouched: 0,
			Adjusted: 0,
		}) as BreakRuleImpact;
	}
	throw new Error(resp.message || "Error checking upcoming breaks");
};

export const upsertBreakRule = async (rule: BreakRule) => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [
		{ name: "BreakRuleId", value: rule.BreakRuleId },
		{ name: "AssetId", value: rule.AssetId },
		{ name: "ShiftHours", value: rule.ShiftHours },
		{ name: "Label", value: rule.Label },
		{ name: "OffsetMinutes", value: rule.OffsetMinutes },
		{ name: "DurationMinutes", value: rule.DurationMinutes },
		{ name: "IsSpell", value: rule.IsSpell },
	];
	return await apiService.callV2("[FAB].[UpsertBreakRule]", parameters);
};

export const deleteBreakRule = async (
	breakRuleId: number,
	includeAdjusted: boolean,
) => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [
		{ name: "BreakRuleId", value: breakRuleId },
		{ name: "IncludeAdjusted", value: includeAdjusted },
	];
	return await apiService.callV2("[FAB].[DeleteBreakRule]", parameters);
};
